module.exports = __webpack_public_path__ + "img/dyp13.b894cd4d.jpg";